import type { Module } from 'vuex';
import { Indicator } from '@/types/Indicator';
import {RootState} from "@/store";

export interface IndicatorsState {
  indicators: Indicator[];
  mathSettings: {
    math: Record<string, any>;
    types: any[];
  };
}

const indicatorsModule: Module<IndicatorsState, RootState> = {
  namespaced: true,

  state: (): IndicatorsState => ({
    indicators: [],
    mathSettings: {
      math: {},
      types: [],
    },
  }),

  getters: {
    getById: (state) => (idIndicator: number): Indicator | undefined => {
      return state.indicators.find(indicator => indicator.idIndicator === idIndicator);
    },
    getFilteredMaths: (state) => {
      const ret: Array<{key: string | null, title: string}> = [];
      ret.push({'key': null, title: 'Не выбрано'});
      Object.keys(state.mathSettings.math).forEach(mathSettingsIndex => {
        ret.push({'key': mathSettingsIndex, title: mathSettingsIndex});
      });
      return ret;
    },
    getFilteredTypes: (state) => {
      const ret: Array<{key: string | null, title: string}> = [];
      ret.push({'key': null, title: 'Не выбрано'});
      (state.mathSettings.types || []).forEach(type => {
        ret.push({'key': type, title: type});
      });
      return ret;
    },
  },

  mutations: {
    setIndicators(
      state,
      payload: { indicators: Record<number, any> }
    ) {
      state.indicators = Object
        .values(payload.indicators)
        .map(raw => Indicator.fromRaw(raw));
    },

    setIndicatorCreate(
      state,
      payload: {
        idIndicator: number;
        name: string;
        math: string;
      }
    ) {
      const raw = {
        idIndicator: payload.idIndicator,
        name: payload.name,
        math: payload.math,
        locked: false,
      };
      state.indicators.push(Indicator.fromRaw(raw));
    },

    setIndicatorUpdate(
      state,
      payload: {
        idIndicator: number;
        name?: string;
        math?: string;
      }
    ) {
      const indicator = state.indicators.find(indicator => indicator.idIndicator === payload.idIndicator);
      if (!indicator) return;
      if (payload.name !== undefined) indicator.name = payload.name;
      if (payload.math !== undefined) indicator.math = payload.math;
    },

    setIndicatorDelete(
      state,
      payload: { idIndicator: number }
    ) {
      state.indicators = state.indicators.filter(
        indicator => indicator.idIndicator !== payload.idIndicator
      );
    },

    setIndicatorLock(
      state,
      payload: { idIndicator: number }
    ) {
      const indicator = state.indicators.find(indicator => indicator.idIndicator === payload.idIndicator);
      if (indicator) indicator.locked = true;
    },

    setIndicatorUnlock(
      state,
      payload: { idIndicator: number }
    ) {
      const indicator = state.indicators.find(indicator => indicator.idIndicator === payload.idIndicator);
      if (indicator) indicator.locked = false;
    },

    setMathSettings(
      state,
      payload: {
        math: Record<string, any>;
        types: any[];
      }
    ) {
      state.mathSettings.math = payload.math;
      state.mathSettings.types = payload.types;
    },
  },

  actions: {
    wsSetIndicators({ commit }, payload) {
      commit('setIndicators', payload);
    },
    wsIndicatorCreate({ commit }, payload) {
      commit('setIndicatorCreate', payload);
    },
    wsIndicatorUpdate({ commit }, payload) {
      commit('setIndicatorUpdate', payload);
    },
    wsIndicatorDelete({ commit }, payload) {
      commit('setIndicatorDelete', payload);
    },
    wsIndicatorLock({ commit }, payload) {
      commit('setIndicatorLock', payload);
    },
    wsIndicatorUnlock({ commit }, payload) {
      commit('setIndicatorUnlock', payload);
    },
    wsSetMathSettings({ commit }, payload) {
      commit('setMathSettings', payload);
    },
  },
};

export default indicatorsModule; 